/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';
import classNames from 'classnames';
import React from 'react';
import { RESPONSE_ITEM_KEY_USE_DEFAULT } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

type Props = {|
  form: string,
  name: string,
  disabled: boolean,
  responses: Array<{
    itemKey: string,
    name: string,
  }>,
|};

const ResponseSelectMenu = ({
  form,
  name,
  disabled,
  responses,
}: Props): Element<typeof SelectMenu> => {
  const items = responses.map(response => {
    const { itemKey, name: responseName } = response;
    return {
      id: itemKey,
      name: responseName || 'Unnamed',
      value: itemKey,
    };
  });

  items.unshift({
    id: RESPONSE_ITEM_KEY_USE_DEFAULT,
    name: 'Use Default',
    value: RESPONSE_ITEM_KEY_USE_DEFAULT,
  });

  return (
    <SelectMenu
      form={form}
      items={items}
      id={name}
      name={name}
      inputClassName={classNames('custom-select', 'derivedFrom-select')}
      disabled={disabled}
    />
  );
};

export default ResponseSelectMenu;
